/**
 * 盘点记录
 */
import React from "react";

import { Modal, Form, InputNumber, Select } from "antd";
import http from "../../../axios/http";
import messager from "../../ui/messager";
const FormItem = Form.Item;

class StockCheckConfigForm extends React.Component {
  state = {
    configData: [],
    config: {
      FullCheckMode: 1,
      FullCheckDay: 1,
      FullCheckMonth: 1,
      RandomCheckDay: 1,
      RandomPercent: 50,
    },
    fullCheckMonthMax: 3,
    changeTime: 0,
  };

  loadConfig() {
    http.post({
      url: "/vehicleStockCheck/configs",
      success: (res) => {
        this.setState({ configData: res });
        var config = this.state.config;
        res.forEach((element) => {
          config[element.ckey] = Number(element.cvalue);
        });
        this.setState({ config });
      },
    });
  }

  componentWillMount() {
    this.loadConfig();
  }

  changeFullCheckMode = (num, e) => {
    var { config, fullCheckMonthMax } = this.state;
    config.FullCheckMode = num;
    fullCheckMonthMax = num === 1 ? 3 : 6;
    this.setState({ config, fullCheckMonthMax });
  };

  changeFullCheckMonth = (num, e) => {
    var { config } = this.state;
    config.FullCheckMonth = num;
    this.setState({ config });
  };

  changeFullCheckDay = (num, e) => {
    var { config } = this.state;
    config.FullCheckDay = num;
    this.setState({ config });
  };

  changeRandomCheckDay = (num, e) => {
    var { config } = this.state;
    config.RandomCheckDay = num;
    this.setState({ config });
  };

  changeRandomPercent = (num, e) => {
    var { config } = this.state;
    config.RandomPercent = num;
    this.setState({ config });
  };

  save = () => {
    const {form } = this.props;
    form.validateFields((err) => {
      if (err) {
        return;
      }
      const { config } = this.state;
      var datas = [
        {
          key: "FullCheckMode",
          value: "" + config.FullCheckMode,
        },
        {
          key: "FullCheckDay",
          value: "" + config.FullCheckDay,
        },
        {
          key: "FullCheckMonth",
          value: "" + config.FullCheckMonth,
        },
        {
          key: "RandomCheckDay",
          value: "" + config.RandomCheckDay,
        },
        {
          key: "RandomPercent",
          value: "" + config.RandomPercent,
        },
      ];
      //保存设置
      http.post({
        url: "/vehicleStockCheck/setConfig",
        data: {
          datas: JSON.stringify(datas),
        },
        success: (res) => {
          messager.notify("操作成功");
          this.props.onCancel();
        },
      });
    });
  };

  render() {
    const { visible, onCancel, form } = this.props;
    const { config, fullCheckMonthMax } = this.state;
    const { getFieldDecorator } = form;
    var formItems = [];
    formItems.push(
      <FormItem label="全盘周期：" key="FullCheckMode">
        {getFieldDecorator("FullCheckMode", {
          initialValue: config.FullCheckMode,
        })(
          <Select onChange={this.changeFullCheckMode}>
            <Select.Option value={0}>半年</Select.Option>
            <Select.Option value={1}>季度</Select.Option>
          </Select>
        )}
      </FormItem>
    );
    formItems.push(
      <FormItem label="全盘日期：" key="FullCheckDay">
        每周期第
        {getFieldDecorator("FullCheckMonth", {
          initialValue: config.FullCheckMonth,
          rules: [{ required: true, message: "请输入全盘月份" }],
        })(
          <InputNumber
            min={1}
            max={fullCheckMonthMax}
            onChange={this.changeFullCheckMonth}
            style={{ width: "50px" }}
          />
        )}
        月 第
        {getFieldDecorator("FullCheckDay", {
          initialValue: config.FullCheckDay,
          rules: [{ required: true, message: "请输入全盘日期" }],
        })(
          <InputNumber
            min={1}
            max={31}
            onChange={this.changeFullCheckDay}
            style={{ width: "50px" }}
          />
        )}
        日
      </FormItem>
    );
    formItems.push(
      <FormItem label="抽盘日期：" key="RandomCheckDay">
        每月
        {getFieldDecorator("RandomCheckDay", {
          initialValue: config.RandomCheckDay,
          rules: [{ required: true, message: "请输入抽盘日期" }],
        })(
          <InputNumber
            min={1}
            max={31}
            onChange={this.changeRandomCheckDay}
            style={{ width: "50px" }}
          />
        )}
        日
      </FormItem>
    );
    formItems.push(
      <FormItem label="抽盘比例(%)：" key="RandomPercent">
        {getFieldDecorator("RandomPercent", {
          initialValue: config.RandomPercent,
          rules: [{ required: true, message: "请输入抽盘比例" }],
        })(
          <InputNumber
            style={{ width: "100%" }}
            min={1}
            max={100}
            onChange={this.changeRandomPercent}
          />
        )}
      </FormItem>
    );
    return (
      <Modal
        visible={visible}
        title="盘点设置调整"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        width="500px"
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          {formItems}
        </Form>
      </Modal>
    );
  }
}
const StockCheckConfig = Form.create()(StockCheckConfigForm);
export default StockCheckConfig;
